// const base = require('./libs/base')
import * as base from './libs/base'
import * as user from './libs/user'

export default {
  ...base,
  ...user
}
